"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startOutdatedVersionPoll = startOutdatedVersionPoll;

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonWrapper = _interopRequireDefault(require("UIComponents/layout/UIButtonWrapper"));

var _loggers = require("customer-data-tracking/loggers");

var FIRST_APPEARANCE = 'FIRST_APPEARANCE';
var REPEAT_APPEARANCE = 'REPEAT_APPEARANCE';

var reload = function reload() {
  return window.location.reload();
};

var addAlert = function addAlert(appearanceType) {
  _loggers.CrmLogger.log('record-interaction', {
    action: 'outdated version banner',
    subAction: appearanceType === FIRST_APPEARANCE ? 'first display' : 'repeat display'
  });

  _FloatingAlertStore.default.addAlert({
    titleText: _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "outdatedVersion.title"
    }),
    message: _react.default.createElement(_UIButtonWrapper.default, null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "outdatedVersion.message"
    }), _react.default.createElement(_UIButton.default, {
      onClick: reload,
      size: "extra-small",
      use: "tertiary"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "outdatedVersion.refresh"
    }))),
    sticky: true,
    type: 'tip',
    use: 'inline',
    onClose: function onClose() {
      _loggers.CrmLogger.log('record-interaction', {
        action: 'outdated version banner',
        subAction: 'dismissed banner'
      });

      setTimeout(function () {
        return addAlert(REPEAT_APPEARANCE);
      }, _I18n.default.moment.duration(3, 'hour').valueOf());
    }
  });
};

function startOutdatedVersionPoll() {
  // https://git.hubteam.com/HubSpot/CRM/pull/14881#discussion_r733088
  // this value is stored as a 32-bit integer and overflows past 24.8 days.
  // Don't let people go 24.8 days without refreshing the CRM. PLease.
  setTimeout(function () {
    return addAlert(FIRST_APPEARANCE);
  }, _I18n.default.moment.duration(1, 'week').valueOf());
}